import React from 'react';

function PrivacyPolicy() {
    return (
        <>
            <div className="2xl:container 2xl:mx-auto lg:py-16 lg:px-20 md:py-12 md:px-6 py-9 px-4">

                <div className="lg:w-10/12 w-full">
                    <h2 className="w-full font-bold text-gray-800 dark:text-gray-400 lg:text-4xl text-3xl lg:leading-10 leading-9 mt-2">
                        Políticas de privacidad
                    </h2>
                </div>

                <div className="mt-6 flex lg:flex-row justify-between flex-col lg:gap-8 gap-12">

                    <div className="w-full">

                        <h3 className="mt-3 font-bold text-gray-800 dark:text-gray-400 text-2xl leading-9">
                            Introducción
                        </h3>

                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            Cuando usas nuestra aplicación nos confías tus datos personales. Nos comprometemos a
                            mantener esa confianza.
                            Para esto, comenzaremos ayudándote a comprender nuestras prácticas de privacidad.
                            Este aviso describe los datos personales que recopilamos, cómo los usamos y compartimos,
                            y tus opciones con respecto a ellos. Recomendamos que leas esto junto con nuestra
                            descripción
                            general de la privacidad, que destaca los puntos clave sobre nuestras prácticas en esta
                            área.</p>

                        <h3 className="mt-3 font-bold text-gray-800 dark:text-gray-400 text-2xl leading-9">
                            Descripción general
                        </h3>

                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            Este aviso se aplica a todos los usuarios de los servicios de Happy Taxi, incluidos los que
                            usan las apps,
                            sitios web, funciones u otros servicios. Este aviso describe cómo Happy Taxi y sus afiliados
                            recopilan y
                            usan los datos personales. También se aplica a todos los usuarios de nuestras apps, sitios
                            web,
                            funciones y otros servicios, a menos que estén cubiertos por otra política.
                            Se aplica específicamente a las siguientes partes:

                        </p>

                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">• Usuarios:
                            Personas que piden viajes
                            o que se transportan, incluidos quienes reciben los servicios programados por un tercero</p>

                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">• Chóferes:
                            Personas que realizan viajes,
                            o aquellos que envían una solicitud a Happy Taxi para hacerlo
                        </p>

                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3"> • Socios
                            Conductores: Personas que brindan servicio de transporte o que envían una solicitud
                            a
                            Happy Taxi para hacerlo, ya sea de manera individual o a través de una empresa asociada
                        </p>


                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Arrendatarios: Personas que rentan bicicletas, motos, u otros vehículos o dispositivos
                            eléctricos ligeros (en conjunto, “Dispositivos de renta”), a través de una app de Happy
                            Taxi.
                        </p>

                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Clientes: Personas que piden nuestros productos y servicios
                        </p>

                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            Este aviso también rige otras recopilaciones de datos personales de Happy Taxi
                            con relación a sus servicios. Por ejemplo, podemos recopilar información de
                            contacto de las personas que usan las cuentas de clientes de Happy Taxi
                            para Empresas, o de propietarios socios de Happy Taxi, así como otros datos con relación a
                            nuestra tecnología y funciones de mapeo. Se hará referencia a todas las personas
                            sujetas a este aviso como “usuarios”. Nuestras prácticas
                            de datos están sujetas a las leyes vigentes en los lugares
                            donde operamos.
                        </p>

                        <h3 className="mt-3 font-bold text-gray-800 dark:text-gray-400 text-2xl leading-9">
                            Datos recopilados
                        </h3>

                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            Happy Taxi recopila lo siguiente: • Datos proporcionados por usuarios a Happy Taxi, como
                            los generados durante la creación de cuentas • Datos creados durante el uso de nuestros
                            servicios,
                            como detalles del dispositivo, ubicación y uso de la app • Datos de otras fuentes, como
                            Socios de
                            Happy Taxi o terceros que usan las API de Happy Taxi La siguiente información es recopilada
                            por
                            Happy Taxi o en su nombre: 1. Datos proporcionados por usuarios. Esto incluye lo siguiente:
                        </p>

                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Perfil de usuario: Recopilamos los datos generados cuando los usuarios crean o
                            actualizan sus cuentas
                            Happy Taxi, lo que puede incluir su nombre, correo electrónico, número de teléfono,
                            nombre de usuario y contraseña,
                            dirección, foto de perfil, detalles de pago o bancarios (incluido su chequeo),
                            documentos de identificación,
                            como números e imágenes de la licencia de conducir, fecha de nacimiento, firma y foto.
                            También se incluye la información de vehículos o de seguros de Socios Conductores y los
                            ajustes del usuario.
                            Podemos usar las fotos enviadas por los Socios Conductores para verificar sus identidades,
                            mediante tecnologías como las de reconocimiento facial.

                        </p>
                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Verificación de antecedentes y de identidad:
                            Recopilamos datos sobre la verificación de antecedentes y de identidad de los Socios
                            Conductores,
                            como el historial de conducción, antecedentes penales (cuando lo permite la ley) y
                            derecho al trabajo.
                            Un proveedor autorizado puede recopilar esta información en nombre de Happy Taxi.
                            También recopilamos datos de la verificación de identidad de los clientes que piden
                            bebidas alcohólicas.

                        </p>
                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Datos demográficos: Podemos recopilar información demográfica sobre los
                            usuarios, incluso a través de
                            las encuestas destinadas a ellos. • Contenido del usuario: Recopilamos la
                            información que los usuarios
                            envían cuando se contactan con el soporte al cliente de Happy Taxi, dan
                            calificaciones o reconocimientos
                            a otros usuarios o a Restaurantes Socios, o contactan a Happy Taxi de alguna
                            otra manera.
                            Esto puede incluir comentarios, fotografías u otras grabaciones recopiladas por
                            los usuarios.
                            2. Datos creados durante el uso de nuestros servicios. Esto incluye lo
                            siguiente:
                        </p>
                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Datos de ubicación: Si el usuario lo permite, recopilamos datos de
                            ubicación precisos o aproximados
                            de su dispositivo móvil. En el caso de los Socios Conductores,
                            Happy Taxi recopila esta información cuando la app de Happy Taxi se ejecuta
                            en primer plano
                            (app abierta y en pantalla) o en segundo plano (app abierta, pero no en
                            pantalla)
                            de su dispositivo móvil. En el caso de los usuarios, clientes y
                            arrendatarios, Happy Taxi
                            recopila estos datos cuando la app de Happy Taxi se ejecuta en primer plano.
                            Los usuarios,
                            clientes y arrendatarios pueden usar las apps de Happy Taxi sin permitir que
                            se recopilen
                            datos de ubicación de sus dispositivos móviles. Sin embargo, esto puede
                            afectar algunas
                            funciones disponibles. Por ejemplo, si un usuario no permite que se
                            recopilen datos de
                            ubicación, deberá ingresar manualmente su punto de partida. Además, los
                            datos de ubicación
                            recopilados de un Socio Conductor o de un dispositivo de renta durante un
                            viaje se vincularán
                            a la cuenta del usuario o del arrendatario, incluso si no permitieron que se
                            recopilen,
                            para generar recibos, brindar soporte al cliente, detectar fraude, y para
                            las aseguradoras
                            y los litigios.
                        </p>
                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Información de transacciones: Recopilamos datos de las transacciones
                            relacionadas con el uso
                            de nuestros servicios, lo que incluye el tipo de servicio solicitado o
                            prestado, detalles del pedido,
                            información de entrega, fecha y hora en que se prestó el servicio, monto
                            cobrado, distancia recorrida
                            y método de pago. Además, si alguien usa un código promo, podemos
                            asociar tu nombre con esa persona.
                        </p>
                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Datos de uso: Recopilamos información sobre cómo los usuarios
                            interactúan con nuestros servicios,
                            como la fecha y la hora de acceso, funciones de la app o páginas
                            vistas, fallos de la app y otras
                            actividades del sistema, tipo de navegador, y sitios o servicios de
                            terceros usados antes de interactuar
                            con nuestros servicios. En algunos casos recopilamos estos datos a
                            través de cookies, píxeles, etiquetas
                            y tecnologías similares que crean y mantienen identificadores
                            exclusivos. • Datos del dispositivo:
                            Podemos recopilar datos sobre los dispositivos usados para acceder a
                            nuestros servicios,
                            lo que incluye modelos de hardware, dirección IP, sistemas
                            operativos y versiones, software,
                            idiomas preferidos, identificadores únicos del dispositivo,
                            identificadores de publicidad,
                            números de serie, e información de movimiento del dispositivo o de
                            las redes móviles.
                        </p>
                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Datos de comunicación: Permitimos que los usuarios se
                            comuniquen entre sí y con Happy Taxi a través
                            de las apps móviles y de los sitios web de Happy Taxi. Por
                            ejemplo, permitimos la comunicación entre
                            Socios Conductores y usuarios, y entre restaurantes o Socios
                            Repartidores y clientes a través de
                            llamadas, SMS o Chat interno. Para brindar este servicio, Happy
                            Taxi recibe ciertos datos relacionados con
                            las llamadas, SMS u otras comunicaciones, como su fecha, hora y
                            contenido. Happy Taxi también puede usar esta
                            información para brindar servicios de soporte al cliente
                            (incluso para resolver disputas entre usuarios),
                            con fines de seguridad, para mejorar nuestros productos y
                            servicios, y para realizar análisis.
                        </p>
                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Datos de dispositivos de renta de vehículos: Recopilamos
                            la información generada por los dispositivos
                            de renta de vehículos, como bicicletas, motos, u otros
                            vehículos o dispositivos eléctricos ligeros, cuando
                            están en uso. Esto incluye la fecha y la hora de uso,
                            ubicación, ruta y distancia recorrida.
                            En la medida en que lo permita la ley, los datos de
                            ubicación recopilados del dispositivo durante
                            el viaje se vincularán a la cuenta del arrendatario, incluso
                            si no permitió que Happy Taxi los obtuviera
                            de su dispositivo móvil. 3. Datos de otras fuentes. Esto
                            incluye lo siguiente:
                        </p>
                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Comentarios del usuario, como calificaciones,
                            opiniones o reconocimientos.
                        </p>
                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Usuarios que participan en nuestros programas de
                            referido. Por ejemplo, cuando un usuario refiere a
                            otra persona,
                            recibimos los datos del invitado.

                        </p>
                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Titulares de cuentas Happy Taxi que piden
                            servicios para otros usuarios o en nombre de
                            estos,
                            o que permiten que estos pidan o reciban
                            servicios a través de sus cuentas, incluidos los
                            titulares
                            de cuentas Happy Taxi para Empresas. • Usuarios
                            u otras personas que proporcionan datos con
                            relación a reclamos o a conflictos.
                        </p>
                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Socios comerciales de Happy Taxi a través
                            de los cuales los usuarios crean o acceden a
                            su cuenta Happy Taxi, como
                            proveedores de pago, servicios de redes
                            sociales, o apps o sitios web que usan las
                            API de Happy Taxi o cuyas API usa Happy
                            Taxi.
                        </p>
                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Proveedores que nos ayudan a verificar
                            la identidad de los usuarios,
                            información de antecedentes y
                            cumplimiento de
                            los requisitos para trabajar con fines
                            reglamentarios y de seguridad.
                        </p>
                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Proveedores de seguros, vehículos
                            o servicios
                            financieros para Socios Conductores.
                        </p>
                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Empresas de transporte
                            asociadas (para Socios
                            Conductores que usan nuestros
                            servicios a
                            través de una cuenta relacionada
                            con dicha empresa).
                        </p>

                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Fuentes disponibles
                            públicamente.
                        </p>

                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            • Proveedores de servicio de
                            marketing. Happy Taxi puede
                            combinar la información
                            recopilada de estas fuentes
                            con otros
                            datos que posea.
                        </p>


                        <h3 className="mt-3 font-bold text-gray-800 dark:text-gray-400 text-2xl leading-9">
                            Actualizaciones a este aviso
                        </h3>

                        <p className="font-normal text-base leading-6 text-gray-600 dark:text-gray-600 mt-3">
                            Es posible que actualicemos este aviso ocasionalmente. El uso de nuestros servicios después de una actualización constituye el consentimiento del aviso modificado en la medida en que la ley lo permita. Es posible que actualicemos este aviso ocasionalmente. Si realizamos cambios significativos, se los notificaremos a los usuarios a través de las apps de Happy Taxi o por otros medios, como por correo electrónico. Le recomendamos a los usuarios revisar periódicamente este aviso para obtener la información más reciente sobre nuestras prácticas de privacidad.
                        </p>

                    </div>

                </div>
            </div>
        </>
    )
        ;
}

export default PrivacyPolicy;